import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { isDefined } from '../../../../../utils/utils';

@Component({
  selector: 'app-form-field-hero-slide',
  templateUrl: './hero-slide-form-field.component.html',
  standalone: false,
})
export class HeroSlideFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  innerHTML: string;

  displayInTable = 'form';

  constructor() {
    super();
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnInit() {
    if (isDefined(this.fieldConfig.category) && isDefined(this.rowData)) {
      if (isDefined(this.rowData.overall) && isDefined(this.rowData.overall[this.fieldConfig.category])) {
        this.innerHTML = this.rowData.overall[this.fieldConfig.category].replace(
          './assets/images/',
          'https://storage.googleapis.com/kickthe/assets/images/'
        );
      } else if (isDefined(this.rowData[this.fieldConfig.category])) {
        this.innerHTML = this.rowData[this.fieldConfig.category].replace(
          './assets/images/',
          'https://storage.googleapis.com/kickthe/assets/images/'
        );
        this.displayInTable = 'table';
      }
    } else {
      if (this.rowData !== undefined && this.rowData.overall !== undefined && this.rowData.overall.html !== undefined) {
        this.innerHTML = this.rowData.overall.html.replace(
          './assets/images/',
          'https://storage.googleapis.com/kickthe/assets/images/'
        );
      }
      if (this.rowData !== undefined && this.rowData.html !== undefined && this.rowData.html !== null) {
        this.innerHTML = this.rowData.html.replace(
          './assets/images/',
          'https://storage.googleapis.com/kickthe/assets/images/'
        );
        this.displayInTable = 'table';
      }
      if (this.data !== undefined) {
        this.displayInTable = 'table';
        this.innerHTML = this.data;
      }
    }
  }

  ngOnDestroy() {}
}
